import { useState, useEffect } from 'react';
import axios from 'axios';

const useTeamCompetitionData = (competitionId) => {
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [statsRequirement, setStatsRequirement] = useState('');
  const [fullRequirement, setFullRequirement] = useState('');
  const [name, setName] = useState('');
  const [group, setGroup] = useState('');
  const [promotionPlayoffSpots, setPromotionPlayoffSpots] = useState('');
  const [promotionSpots, setPromotionSpots] = useState('');
  const [relegationPlayoffSpots, setRelegationPlayoffSpots] = useState('');
  const [relegationSpots, setRelegationSpots] = useState('');
  const [leagueAchievements, setLeagueAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relegationProbs, setRelegationProbs] = useState({}); 

  useEffect(() => {
    const fetchTeamCompetitionData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/league/${competitionId}`);
        
        // POPRAWKA: Rozszerzona destrukturyzacja pobierająca wszystkie brakujące pola z API
        const { 
          teams: teamData, 
          matches: matchData, 
          leagueAchievements, 
          statsRequirement, 
          fullRequirement, 
          relegationProbs: probsData,
          name: fetchedName,
          group: fetchedGroup,
          promotion_spots,
          promotion_playoff_spots,
          relegation_spots,
          relegation_playoff_spots
        } = response.data; 

        setRelegationProbs(probsData || {}); 
        setTeams(teamData);
        setMatches(matchData);
        setLeagueAchievements(leagueAchievements || []); 
        setStatsRequirement(statsRequirement);
        setFullRequirement(fullRequirement);
        
        // POPRAWKA: Zapisujemy dane faktycznie odebrane z API
        setName(fetchedName || '');
        setGroup(fetchedGroup || '');
        setPromotionSpots(promotion_spots || 0);
        setPromotionPlayoffSpots(promotion_playoff_spots || 0);
        setRelegationSpots(relegation_spots || 0);
        setRelegationPlayoffSpots(relegation_playoff_spots || 0);
        
      } catch (err) {
        setError('Błąd podczas pobierania danych tabeli ligi: ' + err.message);
        console.error('Error fetching team competition data:', err);
      } finally {
        setLoading(false);
      }
    };

    if (competitionId) {
      fetchTeamCompetitionData();
    } else {
      setLoading(false);
    }
  }, [competitionId]);

  return { teams, matches, leagueAchievements, relegationProbs, statsRequirement, fullRequirement, name, group, promotionSpots, promotionPlayoffSpots, relegationSpots, relegationPlayoffSpots, loading, error }; 
};

export default useTeamCompetitionData;